
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/circleci/thanks",
      function () {
        return require("private-next-pages/services/circleci/thanks.tsx");
      }
    ]);
  